import React, { Component } from 'react';

import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Pagination.scss';
import { Button } from 'v5/design-system/Button.js';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from 'v5/design-system/Select.js';
import { cn } from 'v5/platform/dom/cn';

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.paging && nextProps.paging.page) {
      if (this.state.currentPage !== nextProps.paging.page) {
        this.setState({ currentPage: nextProps.paging.page });
      }
    }
  }

  changePage = page => {
    const page_count = Math.ceil(
      this.props.paging.total / this.props.paging.count_per_page
    );
    if (page > page_count || page === 0) return;
    this.setState({ currentPage: page }, () => this.props.onPageChange(page));
  };

  renderNumberedPages(totalPages) {
    const pages = Array.from(new Array(totalPages), (val, index) => index + 1);

    return pages.map(page => {
      return (
        <SelectItem key={page} value={String(page)}>
          {page}
        </SelectItem>
      );
    });
  }
  renderCurrentPage = page_count => {
    return (
      <Select
        value={String(this.state.currentPage)}
        onValueChange={page => this.changePage(parseInt(page))}
      >
        <SelectTrigger
          size="sm"
          variant={this.props.variant === 'inline' ? 'ghost' : 'regular'}
          className={
            this.props.variant === 'inline'
              ? ''
              : 'rounded-l-none rounded-r-none -mx-px'
          }
        >
          Page {this.state.currentPage} / {page_count}
        </SelectTrigger>
        <SelectContent className="min-w-(--radix-select-trigger-width)">
          {this.renderNumberedPages(page_count)}
        </SelectContent>
      </Select>
    );
  };
  renderPagination() {
    const { total, count_per_page } = this.props.paging;
    const { currentPage } = this.state;
    const page_count = Math.ceil(total / count_per_page);

    if (total <= count_per_page) {
      return null;
    }

    return (
      <div
        className={classnames(['tailwind-root contents', this.props.className])}
      >
        <div
          className={cn(
            'inline-flex flex-row gap-0 rounded isolate *:focus:z-1',
            this.props.variant === 'inline' ? 'my-[5px]' : ''
          )}
        >
          <Button
            size="sm"
            variant={this.props.variant === 'inline' ? 'ghost' : 'secondary'}
            layout="icon"
            className={this.props.variant === 'inline' ? '' : 'rounded-r-none'}
            onClick={this.changePage.bind(null, parseInt(currentPage) - 1)}
            disabled={currentPage === 1}
          >
            <ChevronLeft />
          </Button>
          {this.renderCurrentPage(page_count)}
          <Button
            size="sm"
            variant={this.props.variant === 'inline' ? 'ghost' : 'secondary'}
            layout="icon"
            className={this.props.variant === 'inline' ? '' : 'rounded-l-none'}
            onClick={this.changePage.bind(null, parseInt(currentPage) + 1)}
            disabled={currentPage >= page_count}
          >
            <ChevronRight />
          </Button>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.paging && this.props.paging.total) {
      return this.renderPagination();
    }
    return null;
  }
}

Pagination.propTypes = {
  className: PropTypes.string,
  paging: PropTypes.shape({
    total: PropTypes.number,
    count_per_page: PropTypes.number,
    page: PropTypes.number // Defaults to 1
  }).isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default Pagination;
